import React from "react";
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from 'react-router-dom'
import hero3 from '../../images/slider/slide-4.jpg'
import hero4 from '../../images/slider/slide-3.jpg'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Hero4 = () => {

    return (
        <section className="wpo-hero-slider">
            <Swiper

                modules={[Navigation, A11y]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1800}
                parallax={true}
                navigation
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero3})` }}>
                        <div className="container">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>BẢO TỒN, PHÁT TRIỂN DI SẢN, VĂN HÓA VÀ VẢI TRUYỀN THỐNG TỈNH CAO BẰNG</h2>
                                </div>
                                <div className="slide-text">
                                    <p>Khám phá vẻ đẹp tinh tế và những câu chuyện văn hóa ẩn chứa trong từng di sản, văn hóa và thước vải truyền thống tỉnh Cao Bằng.</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btn">
                                    <Link onClick={ClickHandler} to="/gallery" className="theme-btn">Bộ sưu tập</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image" style={{ backgroundImage: `url(${hero4})` }}>
                        <div className="container">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2>SỰ ĐA DẠNG CỦA CHẤT LIỆU VẢI VIỆT</h2>
                                </div>
                                <div className="slide-text">
                                    <p>Khám phá vẻ đẹp và giá trị riêng của các loại sợi tự nhiên như sợi lanh, sợi gai, sợi đay... được sử dụng trong ngành dệt truyền thống.</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btn">
                                    <Link onClick={ClickHandler} to="/gallery" className="theme-btn">Bộ sưu tập</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                ...
            </Swiper>
        </section>
    )
}
export default Hero4;
